module.exports = __webpack_public_path__ + "static/img/technology-detail-bot.b8d74fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/detail/technology-detail-bot.jpg
// module id = VbZJ
// module chunks = 1